import { cn } from "../../../utils/className";
import type { TypographyVariant, TypographyAlign } from "./Typography.types";

const categoryAndSectionTitle = cn(
  "text-gray-900",
  "block",
  "text-sm",
  "font-bold",
  "uppercase",
  "tracking-[0.0625rem]"
);

export const typographyStyles = {
  base: cn(
    "block",
    "[unicode-bidi:isolate]",
  ),

  variants: {
    categoryText: categoryAndSectionTitle,
    sectionTitle: categoryAndSectionTitle,
    sectionLargeTitle: ("text-[calc(1.675rem+5.1vw)] xl:text-[5.5rem] leading-[1] text-[var(--color-gray-900)] font-[400]"),
    privacyPolicyTitle: ("text-gray-900  block text-base font-medium  tracking-[0.0625rem]"),
    privacyPolicyDescription: cn("text-[0.9rem] font-style:normal"),
    sectionDescriptionLarge: cn("text-[1.5rem]"),
    sectionHeading: ("text-[calc(1.425rem+2.1vw)] xl:text-[3rem] leading-[1.125] text-[var(--color-gray-900)] font-[400]"),
    darkBackgroundHeading: ("px-8 py-3 bg-[var(--color-gray-950)] rounded-lg mb-6 text-white text-[calc(1.325rem+0.9vw)] xl:text-[2rem]"),    
    sectionDescriptionSmall: cn("text-[1.25rem]"),
    sectionDescriptionSmaller: cn("text-[1.125rem] "),
    sectionDescriptionExtraSmall: cn("text-[1rem]"),    
    anchorSpanText: "text-sm text-gray-900",
    anchorText: "text-sm text-gray-900",
    heroBannerTitle: cn("text-white", "leading-none", "font-normal", "text-[calc(1.675rem+5.1vw)]", "xl:text-[5.5rem]"
    ),
    heroBannerDescription: cn("text-[1.5rem]", "leading-[1.5] text-white"),
    headingH3: cn(
      "text-[calc(1.325rem+0.9vw)]",
      "xl:text-[2rem]",
      "text-[var(--color-gray-900)]",
      "font-normal",
      "leading-[1]",
    ),
    cardDescription: cn(
      "text-base",
      "text-[var(--bs-body-color)]",
      "font-normal",
      "leading-normal"
    ),
    benifitH3: cn(
      "text-[1.5rem]", "font-normal", "text-[var(--color-gray-900)]",
    ),
    imageCardHeading: ("leading-[1.125] text-[calc(1.425rem+2.1vw)] xl:text-[3rem]"),
    imageCardDescription: ("text-[1.25rem] font-light leading-6")
  } as Record<TypographyVariant, string>,

  align: {
    left: "text-left",
    center: "text-center",
    right: "text-right",
    justify: "text-justify",
  } as Record<TypographyAlign, string>,
};
